import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/http/auth.service';
import { TwoFactorService } from './components/two-factor-popup/two-factor.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'identitiy-server-web-app';
  constructor(private router: Router, private authService: AuthService, private twoFactorService: TwoFactorService) {
  }
  public urlContains(part: any) {
    return this.router.url.includes(part);  
  }
}
